module.exports = __webpack_public_path__ + "static/media/petrolpump.cf15084f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/petrolpump.svg
// module id = 7586
// module chunks = 21